import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/images/epispost_favicon_60x60.png"
      {...props}
    />
  );
};

export default Logo;
